module.exports = __webpack_public_path__ + "img/calendar1.90b2c366.svg";